import { useCallback } from 'react'

import { FilterOptionsForIntroducingBrokerRebatePayoutsDto } from '../../../../model/FilterOptionsForIntroducingBrokerRebatePayoutsDto'
import { useAccountReadContext } from '../../../../utils/AccountContextContext'
import { useApiClient } from '../../../../utils/ApiClient'
import { ClientApiClient } from '../../../../utils/clientApi'
import { useFetchOne } from '../../../../utils/useFetch'

export const useIBApprovalsFilterOptions =
  (): FilterOptionsForIntroducingBrokerRebatePayoutsDto => {
    const apiClient = useApiClient(ClientApiClient)
    const { account } = useAccountReadContext()

    const fetchIBRebatePayoutsFilterOptions = useCallback(async () => {
      if (!account?.clientIntroducingBroker?.id) {
        return null
      }

      return apiClient.getIBRebatePayoutsFilterOptions(account.clientIntroducingBroker.id)
    }, [apiClient, account])

    const { data } = useFetchOne(fetchIBRebatePayoutsFilterOptions)

    return {
      tradingAccounts: data?.tradingAccounts || [],
      accountTypes: data?.accountTypes || [],
      groups: data?.groups || [],
    }
  }
